import { Injectable, effect, signal } from '@angular/core';
import { TranslocoService, translate } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {


  public currentLanguage = signal(this.transloco.getActiveLang());
  constructor(private transloco: TranslocoService) {
    effect(() => {
      this.transloco.setActiveLang(this.currentLanguage());
    })
  }



  public getLanguage() {
    return this.currentLanguage.asReadonly();
  }

  public setLanguage(lang: string) {
    this.currentLanguage.set(lang);
  }

  public getTranslation(key: string) {
    return translate(key);
  }

}
